const RIGHT_PANEL_QUERIES = [
  'AllJobsList',
  'UnassignedJobsList',
  'AllOrganizationsCrewsList',
  'OrganizationAllCrewsList',
  'OrganizationUnassignedCrewsList',
];

export default RIGHT_PANEL_QUERIES;
